import {Component} from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
    selector: "app-page-notfound",
    styleUrls: ["page-notfound.component.scss"],
    templateUrl: "page-notfound.component.html",
    imports: [RouterModule],
    standalone: true
})
export class PageNotfoundComponent {

}
